import { useSelector } from "react-redux"
import { OrderDataPrices, OrdersDataType } from "../reducer/orders.reducer"
import { selectSimulatorDate, selectSimulatorOrders, selectSimulatorOrdersPrices } from "../selectors/simulator"
import { useMemo } from "react";

function convertOrdersToPositions(orders: OrdersDataType[], orderPrices: OrderDataPrices[]): Map<number, { order: OrdersDataType; orderPrice: OrderDataPrices }[]> {
    const newOrders: OrdersDataType[] = [...orders]
    const newOrdersPrices: OrderDataPrices[] = [...orderPrices]

    const timeStampToOrders = new Map<number, { order: OrdersDataType; orderPrice: OrderDataPrices }[]>();
    newOrders.forEach((order, i) => {
        if (!order.security || !order.timeStamp || order.sqOffWithOrderId) return;
        const orderPrice = newOrdersPrices[i];
        const key = order.timeStamp
        if (!timeStampToOrders.has(key)) {
            timeStampToOrders.set(key, []);
        }
        timeStampToOrders.get(key)!.push({
            order,
            orderPrice
        })
    })

    return new Map([...timeStampToOrders.entries()].sort((a, b) => a[0] - b[0]));
}

const useTimeWisePositions = () => {
    const timeStamp = useSelector(selectSimulatorDate)
    const simulatorOrders = useSelector(selectSimulatorOrders)
    const simulatorOrdersPrices = useSelector(selectSimulatorOrdersPrices)

    const orders = useMemo(() => simulatorOrders.filter(o=>(o.visibility&&((o.timeStamp??0)<=timeStamp)&&o.traded)), [simulatorOrders, timeStamp])
    const ordersPrices = useMemo(() => simulatorOrdersPrices.filter(o=>(o.visibility&&((o.timeStamp??0)<=timeStamp)&&o.traded)), [simulatorOrdersPrices, timeStamp])

    return convertOrdersToPositions(orders, ordersPrices)
}

export default useTimeWisePositions